import {Divider, Space, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const Validation = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Validation</Paragraph>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '-2%', textAlign: 'center'}}>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Fernando García</Paragraph>
            <Text className='BaseText5'>Coordinator of social entrepreneurship, winner of the 2017 Sustainable Innovation Award by WalMart México and Socialab, with experience in innovation of industries.</Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>Bases of how to start a business</li>
                <li>What is our main problem, the causes and effects. </li>
                <li>How to know if the project is viable, desirable and feasible</li>
                <li>The importance of a pitch in the business model</li>
              </ul>
            </Text>
          </Content>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image width="90%" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-15.jpg'/>
          </Content>
        </Space>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '3%', textAlign: 'center'}}>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image width="90%" src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-16.jpg'/>
          </Content>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh'}}>Emily Hicks</Paragraph>
            <Text className='BaseText5'>Co-founder and President of FREDsense Technologies. As a startup founder, Emily has received several awards  including top 30 under 30 in Canada for Sustainability, the 2018 winner of the She Loves Tech global finals and an Arch award from the University of Calgary for Early Career Achievement. </Text>
            <Paragraph className='Title4' style={{color: appColors['ColorC'], marginTop: '3vh', textAlign: 'center'}}>Knowledge</Paragraph>
            <Text className='BaseText5'>
              <ul>
                <li>Structuring our business model</li>
                <li>How to make the description of the company</li>
                <li>What are our main stakeholders for each part of our entrepreneurial journey</li>
              </ul>
            </Text>
          </Content>
        </Space>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Validation;
